(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/javascripts/models/rules-docs.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/javascripts/models/rules-docs.js'); 
(function(Backbone, svs) {
  'use strict';

  svs.terms_integrity.models.RulesDocs = svs.terms_integrity.models.Base.extend({
    initialize: function() {
      if (svs.terms_integrity.data && svs.terms_integrity.data.rules) {
        this.set({
          rules: svs.terms_integrity.data.rules || {}
        });
      } else {
        this.getDocumentsFromCMS('rules');
      }
    }
  });
})(Backbone, svs);

 })(window);